import { DtoMapper } from '@wemogy/reactbase';
import {IUserStatistic} from '../../models/statistics/UserStatistic';

export default class UserStatisticDtoMapper extends DtoMapper<IUserStatistic, any>{

}
